import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { QcDefectService } from './qc-defect.service';
import { AllQcDefectResponseModel, QcdefectResponsemodel, QcdefectworkstationNameResponseModell, WorkstationRequest } from '@gtpl/shared-models/production-management';
import { QcDefectDto } from './dto/qc-defect.dto';
import { QcDefectRequest, TestNameforoperationrequest, TestNameforoperationrequestQrScan, WorkstationCoderequest, workstationforOperation } from './dto/qc-defect-request';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { QcdefectItemDetailsRequest, QcdefectReportRequest } from './dto/defect-report-request';
@ApiTags('qcdefect ')
@Controller('qcdefect')
export class QcDefectController{
    constructor(
        private qcdefectService:QcDefectService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ){}
  @Post('/createQcDefect')
  async createQcDefect(@Body() qcdefectDto:QcDefectDto,isUpdate:boolean=false): Promise<QcdefectResponsemodel> {
  try {
      return await this.qcdefectService.createQcDefect(qcdefectDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(QcdefectResponsemodel, error);
    }
  }
  @Post('/updateQcDefectDetails')
  async updateQcDefectDetails(@Body() qcdefectdetailsDto: QcDefectDto,@Req() request:Request): Promise<QcdefectResponsemodel> {
    try {
      console.log('update qcdefectdetails');qcdefectdetailsDto
      console.log(request);
      return await this.qcdefectService.createQcDefect(qcdefectdetailsDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(QcdefectResponsemodel, error);
    }
  }
  @Post('/getAllQcDefectDetails')
  // @UseGuards(AuthGuard('jwt'))
  async getAllQcDefectDetails(@Body() req?:QcdefectReportRequest): Promise<AllQcDefectResponseModel> {
    try {
      return await this.qcdefectService.getAllQcDefectDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllQcDefectResponseModel, error);
    }
  }
  @Post('/activateOrDeactivateQcDefectDetails')
  async activateOrDeactivateQcDefectDetails(@Body() req: QcDefectRequest): Promise<QcdefectResponsemodel> {
      try {
          return await this.qcdefectService.activateOrDeactivateQcDefectDetails(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(QcdefectResponsemodel, err);
      }
  }

  @Post('/getAllActiveQcDefectDetails')
  async getAllActiveQcDefectDetails(@Req() request: Request): Promise<AllQcDefectResponseModel> {
      try {
          return await this.qcdefectService.getAllActiveQcDefectDetails();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllQcDefectResponseModel, error)
      }
  }
  @Post('/getActiveQcDefectById')
  async getActiveQcDefectById(@Body() req: QcDefectRequest): Promise<QcdefectResponsemodel> {
      try {
          return await this.qcdefectService.getActiveQcDefectById(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(QcdefectResponsemodel, err);
      }
  }
  @Post('/getWorkstation')
  async getWorkstation(@Body() req:WorkstationCoderequest ): Promise<QcdefectworkstationNameResponseModell> {
      try {
          return await this.qcdefectService.getWorkstation(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(QcdefectworkstationNameResponseModell, err);
      }
  }
  @Post('/getTestnameforOperation')
  async getTestnameforOperation(@Body() req:TestNameforoperationrequest): Promise<CommonResponse>{
    try{
      return await this.qcdefectService.getTestnameforOperation(req);
    }
    catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
  }
  }
  @Post('/getAllActiveWorkstation')
async getAllActiveWorkstation(@Body() req?:workstationforOperation):Promise<CommonResponse>
{
try {
    return await this.qcdefectService.getAllActiveWorkstation(req);
    
} catch (error) {
    throw error;
}
}
@Post('/getAllLotnumbers')
async getAllLotnumbers():Promise<CommonResponse>
{
try {
    return await this.qcdefectService.getAllLotnumbers();
    
} catch (error) {
    throw error;
}
}
@Post('/getTestnameforOperationForScan')
async getTestnameforOperationForScan(@Body() req:TestNameforoperationrequestQrScan): Promise<CommonResponse>{
  try{
    return await this.qcdefectService.getTestnameforOperationForScan(req);
  }
  catch (err) {
    return this.applicationExceptionHandler.returnException(CommonResponse, err);
}
}
@Post('/getTestNameForReport')
async getTestNameForReport():Promise<CommonResponse>
{
try {
    return await this.qcdefectService.getTestNameForReport();
    
} catch (error) {
  return this.applicationExceptionHandler.returnException(CommonResponse, error);
}
}
@Post('/getQcdefectItemByQcId')
async getQcdefectItemByQcId(@Body() req:QcdefectItemDetailsRequest):Promise<CommonResponse>
{
  try{
    return await this.qcdefectService.getQcdefectItemByQcId(req);

  }catch(err){
    return await this.applicationExceptionHandler.returnException(CommonResponse,err)
  }
}
}